import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Content } from '../../../../domain/content/content.model';
import { UrlCleanPipe } from '../../../util/pipes/url-clean/url-clean.pipe';
import { TextPreviewPipe } from '../../../util/pipes/text-preview/text-preview.pipe';
import { MatButtonModule } from '@angular/material/button';
import { DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatCardModule } from '@angular/material/card';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'dottnet-video-list-card',
    templateUrl: 'video-list-card.component.html',
    styleUrls: ['video-list-card.component.scss', '../../content-list-viewer.component.scss'],
    imports: [MatCardModule, RouterLink, MatButtonModule, DatePipe, TextPreviewPipe, UrlCleanPipe]
})
export class VideoListCardComponent {
	readonly content = input<Content>(undefined);
	readonly buttonAction = input<string>(null);
	readonly isPreview = input<boolean>(false);

	constructor() {}
}
